import { lightTheme } from 'thirdweb/react'
import { inAppWallet } from 'thirdweb/wallets'
import staticConfig from '.'
import { thirdwebClient } from 'src/common/api-clients/thirdweb'

export const thirdwebTheme = lightTheme({
  colors: {
    primaryButtonBg: '#8BCA01',
    connectedButtonBg: '#8BCA01',
    connectedButtonBgHover: '#8BCA01',
  },
})

export const thirdwebCommonConnectConfig = {
  client: thirdwebClient,
  theme: thirdwebTheme,
  chain: staticConfig.defaultChain,
  chains: staticConfig.supportedChains,
  wallets: [
    inAppWallet({
      auth: {
        options: ['google', 'apple', 'email'],
      },
    }),
  ],
}
